import React, { useState, useEffect } from "react";
import "./section.css";
import axiosConfig, { HOSPITAL_URL, PROVIDER_URL } from "../../Service/AxiosConfig";
import LoginModal from "../Modals/LoginModal";
import { useNavigate, useLocation } from "react-router-dom";

const Section = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [serviceImage, setServiceImage] = useState(null);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const [selectedServiceId, setSelectedServiceId] = useState();

  const fetchServices = async () => {
    try {
      const response = await axiosConfig.get(
        "catlog/services/?is_suspended=false"
      );
      const data = response.data.results;
      const reordered = [...data];
      setServices(reordered);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchServices();
  }, []);

  const handleClick = (serviceName, serviceId, serviceImage) => {
    const normalized = (serviceName || "").toLowerCase();
    const cleaned = normalized.replace(/[^a-z0-9]/g, "");

    setIsLoginModalOpen(true);
    setName(serviceName);
    setSelectedServiceId(serviceId);
    setServiceImage(serviceImage);
  };

  const handleClose = () => {
    setIsLoginModalOpen(false);
    setName("");
    setName("");
    navigate(`/`);
    setServiceImage(null);
  };
  // const handleBookCare = () => {
  //   navigate("/home-care");
  // };
  const hospitalPartner = () => {
    window.open( HOSPITAL_URL, "_blank");
  };
  return (
    <section className="section-container">
      <div className="left-content">
        <h1>
          Hyderabad's Largest CarePrenuers network Home Healthcare Professionals
        </h1>
        <p>On-Demand. Verified. Compassionate.</p>
        <div className="buttons2">
           {/* <button className="btn" onClick={handleBookCare}>
            Book Home Care Now
          </button> */}
          <button
            className="btn"
            onClick={() => window.open( PROVIDER_URL, "_blank")}
          >
            Join as CarePrenuer
          </button>
          <button className="btn" onClick={hospitalPartner}>
            Hospital Partner Login
          </button>
        </div>
      </div>
      <div className="right-grid">
        {services.map((service, id) => (
          <div
            className="sec-card"
            key={service?.id}
            onClick={() =>
              handleClick(service?.name, service?.id, service?.image?.image)
            }
          >
            <div>
              <img src={service?.image?.image} alt="img" className="icon" />
            </div>
            <p>{service?.name}</p>
          </div>
        ))}
      </div>
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={handleClose}
        serviceId={selectedServiceId}
        title={name}
        image={serviceImage}
      />
    </section>
  );
};

export default Section;
